import axios from '../utils/request';

export const getWeixinSdkParams = () => axios.get('/sdk');

export const createCheck = ({ code }) =>
  axios.post('/check', {
    codeNo: code,
  });
